import { InjectionToken } from '@angular/core';

const _window = typeof window !== 'undefined' ? window : ({} as Window);
export const WINDOW = new InjectionToken<Window>('Window', {
    providedIn: 'root',
    factory: () => {
        return _window;
    },
});
